<template>
    <div class="register-panel">
        <div class="title_img">

        </div>
        <div class="register">
            <div class="register_title">
                <span>用户注册</span>
            </div>
            <el-form :model="registerForm" :rules="rules" ref="registerForm" class="registerForm">
                <el-form-item prop="nickName">
                    <el-input v-model="registerForm.nickName" placeholder="输入昵称" class="nobr" size="meddle"
                        autocomplete="off">
                        <i slot="prefix" class="el-icon-user"></i>
                    </el-input>
                </el-form-item>
                <el-form-item prop="uid">
                    <el-input v-model="registerForm.uid" placeholder="输入登录账号" class="nobr" size="meddle"
                        autocomplete="off">
                        <i slot="prefix" class="el-icon-user"></i>
                    </el-input>
                </el-form-item>

                <el-form-item prop="pwd">
                    <el-input v-model="registerForm.pwd" type="password" show-password placeholder="请输入登录密码"
                        class="nobr" autocomplete="off">
                        <i slot="prefix" class="el-icon-lock"></i>
                    </el-input>
                </el-form-item>
                <el-form-item prop="twoPwd">
                    <el-input v-model="registerForm.twoPwd" type="password" show-password placeholder="请再次输入登录密码"
                        class="nobr" autocomplete="off">
                        <i slot="prefix" class="el-icon-lock"></i>
                    </el-input>
                </el-form-item>


                <el-form-item prop="email">
                    <el-input v-model="registerForm.email" placeholder="输入邮箱" class="nobr" size="meddle"
                        autocomplete="off">
                        <i slot="prefix" class="el-icon-user"></i>
                    </el-input>
                </el-form-item>


                <el-form-item prop="mobile">
                    <el-input v-model="registerForm.mobile" placeholder="请输入手机号" class="nobr" autocomplete="off">
                        <i slot="prefix" class="el-icon-lock"></i>
                    </el-input>
                </el-form-item>
                <el-form-item required>
                    <el-col :span="18">
                        <el-form-item prop="validCode">
                            <el-input v-model="registerForm.validCode" placeholder="请输入验证码（忽略大小写）"
                                class="nobr"></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="6" align="right">
                        <img ref="refresh" style="width: 100px;height: 30px;cursor: pointer;" :src="validImg"
                            @click="getValidCode"></img>
                    </el-col>
                </el-form-item>
                <el-form-item required>
                    <el-col :span="18">
                        <el-form-item prop="smsCode">
                            <el-input v-model="registerForm.smsCode" placeholder="请输入验证码" class="nobr"
                                autocomplete="off">
                                <i slot="prefix" class="el-icon-lock"></i>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" align="right">
                        <el-button type="primary" class="nobr verifybtn" style="" :loading="loading"
                            @click="getSmsCode()">发送验证码</el-button>
                    </el-col>
                </el-form-item>


                <el-form-item>
                    <el-button type="primary" class="nobr loginbtn" style="" :loading="loading"
                        @click="goLogin()">登录</el-button>
                    <el-button type="primary" class="nobr registerbtn" style="" :loading="loading"
                        @click="register">注册</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>

import { useRouter, useRoute } from 'vue-router';
import { getCode, userRegister, getSmsCode, setAPassword } from '@/api/Common.js';

export default {
    name: 'Register',
    components: {

    },
    data() {
        return {
            validImg: "",
            validKey: "",
            registerForm: {
                email: "",
                nickName: "",
                uid: "",
                pwd: "",
                twoPwd: "",
                mobile: "",
                validCode: "",
                smsCode: "",

            },
            router: null
        }
    },
    mounted() {
        this.router = useRouter();
        this.getValidCode();
    },
    methods: {
        getValidCode() {
            getCode().then(res => {
                this.validImg = "data:image/bmp;base64," + res.img;
                this.validKey = res.uuid;
            })
        },

        register() {
            let that = this;
            userRegister({
                "email": this.registerForm.email,
                "mobile": this.registerForm.mobile,
                "nickName": this.registerForm.nickName,
                "password": this.registerForm.pwd,
                "twoPassword": this.registerForm.twoPwd,
                "smsCode": this.registerForm.smsCode,
                "userName": this.registerForm.uid,
                "verificationCode": this.registerForm.validCode,
                "verificationCodeKey": this.validKey
            }).then(res => {
                alert(res.msg);
                if (res.code == 200) {
                    setAPassword({
                        "password": that.registerForm.pwd,
                        "twoPassword": that.registerForm.twoPwd,
                        "userName": that.registerForm.uid,
                    }).then(res => {
                        if (res.code == 200) {
                            that.router.push({ path: "/login" });
                        }
                    })
                }
            })

        },
        getSmsCode() {
            getSmsCode({
                "mobile": this.registerForm.mobile,
                "verificationCodeKey": this.validKey,
                "verificationCode": this.registerForm.validCode,
            }).then(res => {
                console.log(res);
            })
        },
        goLogin() {
            this.router.push({ path: "/login" });
        },
        submitForm(formName) {
        }
    }
}
</script>

<style scoped>
.register-panel {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    background: url("../assets/images/login.jpg") no-repeat center;
    background-size: 100% 100%;
}

.register {
    width: 472px;
    height: 671px;
    position: absolute;
    left: 75%;
    top: 45%;
    transform: translate(-50%, -40%);
    background: rgba(255, 255, 255, 0.9);
    border-radius: 8px;
}

.register_title {
    margin-top: 47px;
    margin-left: 48px;
    font-size: 25px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #3b4d6e;
    /* background-color: #bfa; */
}

.registerForm {
    margin-top: 21px;
    margin-left: 48px;
    /* background-color: #bfa; */
    width: 385px;
}

.el-form-item {
    /* margin-bottom: 12px; */
    height: 41px;
}

.el-input /deep/ .el-input__inner {
    /* background: rgba(80, 152, 255, 0.24); */
    border-color: rgba(0, 0, 0, 0.1);
    color: #000;
}

.el-input /deep/ .el-input-group__prepend {
    border: 0;
    padding: 0 !important;
}

.verifybtn {

    background: #3b4d6e;
    margin-left: 5px;
}

.loginbtn {
    width: 180px;
    height: 50px;
    background: #3b4d6e;
    border-radius: 5px;
}

.registerbtn {
    width: 180px;
    height: 50px;
    background: #3b4d6e;
    border-radius: 5px;
}
</style>